export default __webpack_public_path__ + "static/media/heroImg.ee9ceba2.png";